import { render, staticRenderFns } from "./capsuleBanner.vue?vue&type=template&id=73bceeec&scoped=true&"
import script from "./capsuleBanner.vue?vue&type=script&lang=js&"
export * from "./capsuleBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bceeec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bceeec')) {
      api.createRecord('73bceeec', component.options)
    } else {
      api.reload('73bceeec', component.options)
    }
    module.hot.accept("./capsuleBanner.vue?vue&type=template&id=73bceeec&scoped=true&", function () {
      api.rerender('73bceeec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/capsuleBanner.vue"
export default component.exports